import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Prose from "../utility/prose";

const Budget = () => {
    const data = useStaticQuery(graphql`
        query {
            allStrapiBudget (sort: {year: DESC}) {
                nodes {
                    id
                    year
                    revenue
                    maintenance_operations_tax_revenue
                    debt_service_tax_revenue
                    expenses
                    budget {
                        localFile {
                            publicURL
                        }
                    }
                }
            }
        }
  `)

    const nodes = data.allStrapiBudget.nodes
    return (
        <Prose>
            <h2>Budget for the Current and Prior Years</h2>

            {nodes.map( entry => (
                <span className="not-prose" key={entry.id}>
                { entry.budget === null ? (<></>) : (<a className="inline-block bg-zinc-200 hover:bg-zinc-300 dark:bg-zinc-800 hover:dark:bg-zinc-900 mr-1 mb-2 px-4 py-2 rounded-full leading-none" target="_blank" rel="noreferrer noopener" href={entry.budget.localFile.publicURL}>Budget FYE {entry.year}</a>)}
                </span>
            ))}

            <p>
            <strong>Change in the District's Revenue from {nodes[1].year} to {nodes[0].year} : </strong> $&nbsp;{(nodes[0].revenue-nodes[1].revenue).toFixed(0).replace(/\d(?=(\d{3})+$)/g, '$&,')}&nbsp;&nbsp;|&nbsp;&nbsp;{((nodes[0].revenue-nodes[1].revenue)/nodes[1].revenue*100).toFixed(2)}%<br />
            <strong>Change in the District's Expenses from {nodes[1].year} to {nodes[0].year}:</strong> $&nbsp;{(nodes[0].expenses-nodes[1].expenses).toFixed(0).replace(/\d(?=(\d{3})+$)/g, '$&,')}&nbsp;&nbsp;|&nbsp;&nbsp;{((nodes[0].expenses-nodes[1].expenses)/nodes[1].expenses*100).toFixed(2)}%</p>
            <h3>Property Tax Revenue Budgeted for Maintenance & Operations and for Debt Service</h3>
            <table className="w-full md:w-2/3 lg:w-2/3 text-center">
                <thead>
                <tr>
                    <th>Year</th>
                    <th>Debt Service</th>
                    <th>Maintenance & Operations</th>
                </tr>
                </thead>
                <tbody>
                {nodes.map( entry => {
                return (
                <tr>
                    <td>{entry.year}</td>
                    <td>$&nbsp;{entry.debt_service_tax_revenue.toFixed(0).replace(/\d(?=(\d{3})+$)/g, '$&,')}</td>
                    <td>$&nbsp;{entry.maintenance_operations_tax_revenue.toFixed(0).replace(/\d(?=(\d{3})+$)/g, '$&,')}</td>
                </tr>
                )})}
                </tbody>
            </table>
        </Prose>
    )
}

export default Budget